import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import UsersPage from "@/pages/Users";
import RolesPermissions from "@/pages/RolesPermissions";
import BarSettings from "@/pages/BarSettings";
import Schedule from "@/pages/Schedule";
import MySchedule from "@/pages/MySchedule";
import Hours from "@/pages/Hours";
import Reports from "@/pages/Reports";
import Tickets from "@/pages/Tickets";
import TicketDetail from "@/pages/TicketDetail";
import Orders from "@/pages/Orders";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-zinc-950"><div className="text-amber-500 animate-pulse font-heading text-xl">Cargando...</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-zinc-950"><div className="text-amber-500 animate-pulse font-heading text-xl">Cargando...</div></div>;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/roles-permissions" element={<RolesPermissions />} />
        <Route path="/bar-settings" element={<BarSettings />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/my-schedule" element={<Schedule />} />
        <Route path="/hours" element={<Hours />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/tickets/:id" element={<TicketDetail />} />
        <Route path="/orders" element={<Orders />} />
      </Route>
      <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
